import * as Yup from 'yup';

export const updateSubjectIdSchema = Yup.object().shape({
    subjectId: Yup.string().required('Subject Id is required')
});
